import { JUMP_TYPE_ENUM } from '../enums';
import { LOGIN_STATUS_BT, REG_LOGIN_SUCCESS_SW } from '../enums/track';
import { isJumpOneLink } from '../store/index';

import { mediaEventUpOnce } from './eventUp';
import { JumpLink } from './jumpTo';
import { normalizePassportLoginData, setCookieConfig } from './passport';
import { trackEvent } from './track';

import { trackEventModuleSw } from '@/utils/techTrack';
import url from '@/utils/url';

/** 广告转化：登录成功仅上报 5002；5001 由 HTML adv 初始化（pageInfo.swEventId）上报 */
export const CREDIT_CARD_LOGIN_MEDIA_EVENT = 5002;

export const handleAppLoginSuccess = (raw: {
    ticket: string;
    cell: string;
    uid: string;
    uid_str?: string;
}) => {
    const loginData = normalizePassportLoginData(raw);

    if (!loginData) {
        console.error('[MXCreditCardBALL] login success payload invalid', raw);

        return;
    }

    setCookieConfig(loginData);
    trackEventModuleSw('login_success');
    trackEvent(REG_LOGIN_SUCCESS_SW, { is_sign_success: 1 });
    trackEvent(LOGIN_STATUS_BT, { is_sign_success: 1 });
    mediaEventUpOnce(CREDIT_CARD_LOGIN_MEDIA_EVENT, {
        uuid: url.get('outcast_uuid') || window.adv?.getAdvUUID?.(),
        mobile: loginData.cell,
        callingCode: '52',
        uid: loginData.uid
    });
    isJumpOneLink.set(true);
    setTimeout(() => {
        JumpLink(JUMP_TYPE_ENUM.TO_H5CREDITCARD);
    }, 1500);
};
